<template>
  <RoomChatForm type="my-chat"
              v-show="myChatList.length"
              :item="allMyChats"/>
</template>

<script>

import _ from "lodash";
import {mapGetters, mapMutations} from "vuex";
import RoomChatForm from '@/components/Room/Chat/RoomChatForm'

export default {
  name: 'RoomMyChat',
  components:{
    RoomChatForm,
  },
  data() {
    return {
      debounce: null,
    }
  },
  created() {
    this.debounce = _.debounce(this.CLEAR_MY_CHAT, 10000);
  },
  destroyed() {
  },
  watch:{
    allMyChats(val) {
      if (val){
        this.debounce();
      }
    },
  },
  computed: {
    ...mapGetters('chat', [
      'myChatList',
    ]),
    ...mapGetters('user', [
        'me',
    ]),
    allMyChats(){
      let myChats = this.myChatList.map(c => c.text.escapeXml()).join(`\r`)
      return {
        nickname: this.me.nickname,
        myChats
      }
    },
  },
  methods: {
    ...mapMutations('chat', [
      'CLEAR_MY_CHAT',
    ]),
  }
}

</script>